import { Controller } from 'stimulus';

export default class extends Controller {
  async update(event) {
    event.preventDefault();

    const element = event.target;
    const form = element.form;

    if (!element.validity.valid) {
      element.reportValidity();
      return;
    }

    const response = await fetch(form.action, {
      method: 'PATCH',
      body: new FormData(form),
    });

    if (!response.ok) {
      alert('An error occurred. Please try again.');
      return;
    }

    const html = await response.text();
    const fragment = document.createRange().createContextualFragment(html);
    this.element.replaceChildren();
    this.element.appendChild(fragment);
  }
}
